import { render, staticRenderFns } from "./MarketingConserve.vue?vue&type=template&id=650db876&scoped=true"
import script from "./MarketingConserve.vue?vue&type=script&lang=js"
export * from "./MarketingConserve.vue?vue&type=script&lang=js"
import style0 from "./MarketingConserve.vue?vue&type=style&index=0&id=650db876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650db876",
  null
  
)

export default component.exports